import { Component, OnInit, signal } from '@angular/core';
import { ActionType } from '@app/core/enums/ecmr/ActionType';
import { HistoryLog } from '@app/shared/models/ecmr/HistoryLog';
import { DateTimeService } from '@app/core/services/ecmr-services/date-time.service';
import { ActivatedRoute } from '@angular/router';
import { HistoryLogsService } from '@app/core/services/ecmr-services/history-logs.service';
import { lastValueFrom } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@app/shared/material/material.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-ecmr-history-logs',
    templateUrl: './ecmr-history-logs.component.html',
    styleUrl: './ecmr-history-logs.component.scss',
    imports: [CommonModule, MaterialModule, TranslateModule],
})
export class EcmrHistoryLogsComponent implements OnInit {
    protected readonly ActionType = ActionType;

    historyLogs = signal<HistoryLog[]>([]);
    ecmrId: string = '';
    referenceId: string = '';

    constructor(
        protected dateTimeService: DateTimeService,
        private route: ActivatedRoute,
        private historyLogService: HistoryLogsService
    ) {}

    async ngOnInit() {
        this.ecmrId = this.route.snapshot.params['id'];
        this.referenceId = this.route.snapshot.params['refId'];

        this.historyLogs.set(
            await lastValueFrom(
                this.historyLogService.getHistoryLogs(this.ecmrId)
            )
        );
    }

    back() {
        window.history.back();
    }
}
